import { request } from './client'

/* **M-15 — NEEDS YOU.** Sprint 47.

   Pack 6 draws four cards and one sentence under them: *"These are the same four cards a
   supervisor sees on the web. Nothing is supervisor-only on one platform and missing from
   the other — a supervisor who has to go and find a computer to act on something they were
   just alerted to will stop trusting the alert."*

   So this module is in the SHARED CORE and both clients import it. See `IEscalationQuery`
   on the server. */

/** The four. Never translated — a report counts by these and a screen branches on them.
 *
 *  A union and not a string, so the day a fifth card is added every screen that turns one
 *  of these into a sentence stops compiling rather than silently drawing nothing. */
export type AlertCode =
  | 'alert.soldRoomOutOfOrder'
  | 'alert.requestsLate'
  | 'alert.repeatFailure'
  | 'alert.stockBelowPar'

export interface Escalation {
  code: AlertCode
  /** How late, in minutes. **Null is not zero**: a shelf is "today" and a guest is "now". */
  minutesOver: number | null

  roomId: string | null
  roomNumber: string | null
  arrivalUtc: string | null

  /** Who it is about. The repeat-failure card names the attendant. */
  personName: string | null
  personNameAr: string | null

  /** What it is about: the item that keeps failing, the stock that is short. */
  subjectName: string | null
  subjectNameAr: string | null

  /** How many things this card stands for. One card per problem, not per row. */
  count: number
  /** What the card lists underneath. Never translated. */
  references: string[]
  /** Somebody's own words. Never translated, and drawn in its own direction. */
  detail: string | null

  /** Late requests only: how many nobody has taken. */
  neverAccepted: number | null

  /** Stock only. */
  quantity: number | null
  parLevel: number | null
  /** Stock only, at the last fortnight's rate. Null where nothing has moved.
   *  A WHOLE NUMBER OF DAYS, floored for printing. Never judge from it — see below. */
  daysOfCover: number | null
  /**
   * **THE SHELF RUNS OUT BEFORE THE LAUNDRY CAN GET IT BACK** — CQ-142, answered
   * 17 September: linen takes 24 hours, and the card speaks below a day and a half of
   * cover.
   *
   * **DECIDED ON THE SERVER, WHICH IS UNUSUAL HERE AND DELIBERATE.** Every other
   * judgement of this kind — `laneStanding`, `bestFitFor` — is derived on the client from
   * a shared rule, because the client has the same facts the server does. Here it does
   * not: `daysOfCover` is floored for printing, so a shelf with 1.9 days of cover arrives
   * as `1`, and a client deciding from that would call it unrecoverable when it has
   * nearly two days. The precision lives on the server, so the judgement does too.
   */
  laundryCannotReplace: boolean
}

export const fetchEscalations = (
  options: { signal?: AbortSignal } = {},
): Promise<Escalation[]> => request<Escalation[]>(
  '/me/escalations', options.signal ? { signal: options.signal } : {})
